const dashboard = '/dashboard';
const login = '/login';
const error = '/error';
const register = 'register';
const organization = 'organization';
const roles = 'roles';
const userDetails = 'user_details';
const permissions = 'permissions';
const incentiveProgram = 'incentive_program';
const attribute = 'user_attr_master_mapping';
const profile = '/profile';
const bulkUser = '/bulk_User';
const communicationHub = 'communication_hub';
const nudgeConfiguration = 'nudge_configuration';
const templateDetails = 'template_details';
const audienceGrouping = 'audience_group';

const routeName = {
  dashboard,
  login,
  error,
  register,
  userDetails,
  organization,
  roles,
  permissions,
  incentiveProgram,
  attribute,
  profile,
  bulkUser,
  communicationHub,
  nudgeConfiguration,
  templateDetails,
  audienceGrouping,
};

export default routeName;
